// api/axiosInstance.ts
import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const nodeApi = axios.create({
  baseURL: apiBaseUrl || "https://challan-backend.sirpi.co.in/api",
  // baseURL: "http://localhost:5000/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default nodeApi;
